import { EventFields } from "../../types/request.types";
import { formatDate, formatTime } from "../../lib/date-time-formatters";

import classes from "./Request.module.css";

interface EventProps {
  request: EventFields;
}

function formatTimeFields(request: EventFields, fieldType: 'start' | 'end') {
  let formatted: string[] = []
  const date = request[`${fieldType}_date`];
  const time = request[`${fieldType}_time`];

  if (date)
    formatted.push(formatDate(date));

  if (time)
    formatted.push(formatTime(time));

  return formatted.join(' – ');
}

const Event = ({ request }: EventProps) => (
  <dl className={classes.details}>
    <dt>Name</dt>
    <dd>{request.name}</dd>
    <dt>Description</dt>
    <dd dangerouslySetInnerHTML={{__html: request.description || ''}}></dd>
    <dt>Sponsors</dt>
    <dd>{request.sponsors}</dd>
    <dt>Audience</dt>
    <dd>{request.audience?.join(', ')}</dd>
    <dt>Campus</dt>
    <dd>{request.campus}</dd>
    <dt>Location</dt>
    <dd>{request.location}</dd>
    <dt>Start</dt>
    <dd>{formatTimeFields(request, 'start')}</dd>
    <dt>End</dt>
    <dd>{formatTimeFields(request, 'end')}</dd>
    <dt>Cost</dt>
    <dd>{request.cost}</dd>
    <dt>Why is it exciting for the JCC community?</dt>
    <dd dangerouslySetInnerHTML={{__html: request.why_exciting || ''}}></dd>
    <dt>Types of marketing</dt>
    <dd>{request.marketing_types?.join(', ')}</dd>
    <dt>Career Communities</dt>
    <dd>{request.career_communities?.map(cc => cc.name).join(', ')}</dd>
    <dt>Requested completion date</dt>
    <dd>
      {request.requested_completion_date && formatDate(request.requested_completion_date)}
    </dd>
  </dl>
);

export default Event;
